import React from "react";
import Drawer from "../common/Drawer";
import styles from "./ProfileDrawers.module.css";
import { RELEASE_NOTES } from "../../data/releaseNotes";

const SEEN_KEY = "productUpdatesSeen";
const readSeen = () => { try { return localStorage.getItem(SEEN_KEY) || ""; } catch { return ""; } };

export const countUnseenUpdates = () => RELEASE_NOTES.filter((n) => n.date > readSeen()).length;
export const markUpdatesSeen = () => { try { localStorage.setItem(SEEN_KEY, RELEASE_NOTES[0].date); } catch { /* private mode */ } };

const formatDate = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

export default function ProductUpdatesDrawer({ onClose }) {
  return (
    <Drawer title="Product updates" onClose={onClose}>
      {RELEASE_NOTES.map((note) => (
        <article key={note.date} className={styles.note}>
          <time className={styles.noteDate}>{formatDate(note.date)}</time>
          <h3>{note.title}</h3>
          <p>{note.body}</p>
        </article>
      ))}
    </Drawer>
  );
}
